import Chip from "@material-ui/core/Chip";
import CheckIcon from "@material-ui/icons/Check";
import FilterListIcon from "@material-ui/icons/FilterList";
import StoreIcon from "@material-ui/icons/Store";
import { ICopyProps } from "actions/collections/collection";
import Tile from "components/icons/layout/tile";
import { Table as TableIcon } from "components/icons/table";
import { Timeline } from "components/icons/timeline";
import { ProductCollectionContext } from "components/product-collection/product-collection-context";
import {
    TotalTypes,
    ICurrency,
} from "components/product-collection/product-collection-views/product-collection-grid-view/grid-renderers/pinned-row-renderers";
import { DATATEST } from "constants/integration";
import {
    CollectionAction,
    GridParamType,
    SizeAllocationType,
    View,
    ISizePacksTolerance,
    TileViewSize,
    CollectionKeys,
    ATTRIBUTE_GROUP_DELIMITER,
    IExportParams,
} from "constants/product-collection";
import { ISuggestionItem, ISuggestionObject } from "containers/product-collections/product-collection-cart";
import { IAllocationDimension, AllocationBag } from "helpers/allocation-dimension";
import { IDeliveryPurchaseOrder, IPurchaseOrderDoorGroup } from "helpers/delivery-purchase-order";
import { getAttributeFilters, getDimensionFilters } from "helpers/door-collection";
import { IDisplayFields, ISchemaKey } from "helpers/product-collection";
import { List, Map, Set } from "immutable";
import { formatMessage } from "lib/globalize-util";
import { isEmpty } from "lodash";
import React from "react";
import ReactDOM from "react-dom";
import { ISubscription } from "reducers/subscriptions";
import siteConfig from "site-config";
import { CurrentSavedViewChip } from "../product-collection-current-saved-view-chip";
import { ProductCollectionActions, ProductRollupActionsView } from "../product-collection-header-components";
import { SearchAssortments } from "../product-collection-search-assortments";
import {
    CollectionSavedViewRollupSeparator,
    IGridParamsQueryParam,
} from "../product-collection-views/product-collection-grid-view/tool-panels";
import Button from "./button";
import NestedViewButton, { IViewSubItem, MenuItemType } from "./nested-view-button";
import { nameExtRemover } from "containers/folders/utils/space-item";
import { ItemKind } from "containers/folders/types/base";
import { IGridData } from "helpers/collection";
import { IDoorTotals } from "reducers/collection";
import { ICollectionVersionStatus } from "helpers/collection-version-status";
import { ITileSettings } from "../manage-tile-view/types";
import { CUSTOM_VIEW_SETTINGS, DEFAULT_VIEW_SETTINGS } from "../manage-tile-view/constants";
import TileSmall from "components/icons/layout/tile-sm";
import TileMedium from "components/icons/layout/tile-med";
import TileLarge from "components/icons/layout/tile-lg";
import { IFetchBrandsDataPayload } from "actions/brands-data-actions";
import { IBrandsDataStatePayload } from "reducers/brands-data-reducers";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FeatureFlags } from "helpers/feature-flags";
import { getTotalTypesLabel } from "helpers/metrics/legacy-metrics";
import { DimensionsPanelReduxState } from "reducers/dimensions-panel/dimensions-panel";
import { menuItemStyles, nestedViewButtonStyle, toolbarStyles } from "./styles";
import { views } from "./constants";
import { ProductCollectionToolbarFilters } from "./product-collection-toolbar-filters";
import { IFilters } from "./product-collection-toolbar-filters/types";
import * as CustomChip from "components/chip/chip";
import { Distribution as DistributionIcon } from "components/icons/assortments/distribution";
import { Distribution } from "actions/collections/collection-settings";
import { DEFAULT_DISTRIBUTION_OPTION } from "../footer/components/left-side/manage-distribution-modal/manage-distribution-modal";

interface IProps {
    defaultSearchText: { value: string };
    searchText?: string;
    hashtags: Set<string>;
    isMobileOrPhablet: boolean;
    isMobileOrPhaTablet: boolean;
    onClearViewSettings: () => void;
    onSearchChange: (searchText, force?) => void;
    onSwitchView: (view: View) => void;
    onToggleTotals: () => void;
    view: View;
    gridParams: IGridParamsQueryParam;
    location: any;
    onUndo: React.MouseEventHandler<HTMLElement>;
    onRedo: React.MouseEventHandler<HTMLElement>;
    editable: boolean;
    capabilities: nuorder.folder.v1.Capabilities;
    collectionDriveItem: nuorder.folder.v1.Item;
    collection?: any;
    onDeleteCollection: (id: string) => void;
    collectionId: string;
    syncingProducts: boolean;
    allocatingAssortment: boolean;
    findingSizes: boolean;
    onSyncProductsStart: (isFiltered?: boolean) => void;
    onSyncProductsStop: () => void;
    gridApi?: any;
    itemDisplayProperty?: List<any>;
    rowDataSet: boolean;
    onExport: (params?: IExportParams) => void;
    onCreateNordstromPush: (params: any) => any;
    collectionExport: any;
    onClearCollectionExport: () => void;
    brandsDataById: IBrandsDataStatePayload["brandsDataById"];
    onCopy: (params: ICopyProps) => void;
    onToggleAddSMUDialog: () => void;
    onToggleImageGroups: () => void;
    onClearViewParams: () => void;
    onFiltersChange: (filter: IFilters) => void;
    requiredFieldNames: string[];
    desiredFieldNames: string[];
    getSuggestionData: () => ISuggestionObject;
    setSuggestionData: (data: ISuggestionItem[], storeKey: string) => void;
    handleFocusOnCellMap: () => Map<string, any>;
    onRemovePermission: (params) => void;
    user: IUser;
    showTimeline: boolean;
    onToggleTimeline: () => void;
    showTotals: boolean;
    doorClassificationSchema: ISchemaKey[];
    onToggleDoors: () => void;
    showDoors: boolean;
    onChangeDoorGrouping: (event: React.MouseEvent, doorGrouping: string) => void;
    onChangeDoorGroupingLabel: (event: React.MouseEvent, doorGrouping: string) => void;
    onChangePlanMetric: (event: React.MouseEvent, doorGrouping: string) => void;
    doorGrouping?: string;
    doorGroupingLabel?: string;
    dimensionPlanMetrics: string[];
    onSubscribe: (targetFeedId: string) => void;
    onUnsubscribe: (targetFeedId: string) => void;
    subscription: ISubscription;
    onAllocateAllRows: (action: CollectionAction) => void;
    allocationEnabled: boolean;
    sizingCurveEnabled: boolean;
    sizingRangeEnabled: boolean;
    sizePackEnabled: boolean;
    onMatchSelectedSizesWithSizeRangesAllRows: (action: CollectionAction) => void;
    onToggleManageDoorGrouping: () => void;
    onToggleManageAllocationDimension: () => void;
    onToggleManagePurchaseOrders: () => void;
    allocationDimensions: IAllocationDimension[];
    allocationDimensionGroups: IAllocationDimension[];
    accessPlan: boolean;
    bulkItems: any;
    itemId?: string;
    merchantId: string;
    legacyMerchantId: string;
    onOpenProductModal: (id) => void;
    showManagePurchaseOrder: boolean;
    merchantPurchaseOrderDoorGroups: IPurchaseOrderDoorGroup[];
    deliveryPurchaseOrders: IDeliveryPurchaseOrder[];
    sizeAllocationType?: SizeAllocationType;
    onOpenExportToMerchant: (validate) => void;
    merchantCurrency?: ICurrency;
    tileViewData?: IGridData;
    uniqueBrandEntities?: any[];
    listMerchantCollectionVersionStatutes: ICollectionVersionStatus[];
    onAddCollectionTag: (id: string) => void;
    onRemoveCollectionTag: () => void;
    poiTags: List<any>;
    currentPoi?: string;
    fetchMerchantPreference: (merchantId) => void;
    fetchMerchantAllocationDimensions: (merchantId) => void;
    genericMerchantAllocationDimensions: IAllocationDimension[];
    requestingMerchantAllocationDimensions: boolean;
    defaultDateFormat?: string;
    onConfigureTileView: () => void;
    onApplyTileViewTemplate: (tileSettings: ITileSettings, selectedTileViewKey: number) => void;
    onResetToDefaultTileView: () => void;
    selectedTileViewKey: number | string;
    sizePacksTolerance: ISizePacksTolerance | null;
    updateCollectionSizePacksTolerance: (params: ISizePacksTolerance | null) => void;
    isFetchingBrandsData: boolean;
    onFetchBrandsData: (query: IFetchBrandsDataPayload["query"]) => void;
    onConfigureTileViewSize: (tileViewSize: string) => void;
    tileViewSize: string;
    merchantFeaturePreference?: nuorder.collection.merchant_feature_config.MerchantFeatureConfig;
    onSyncInventoryUnitsAllRows: (action: CollectionAction) => void;
    syncingInventoryUnits: boolean;
    isCloseoutAssortmentEnabled: boolean;
    userMerchantId: string;
    isServerRollup: boolean;
    onToggleExpandAllGroups: () => void;
    expandAllGroups: boolean;
    doorTotals?: IDoorTotals;
    doorTotalsFiltered?: IDoorTotals;
    allocationBagRef?: {
        allocationBag: AllocationBag;
    };
    hideDoorsOptions: boolean;
    rootNodeOverride?: HTMLElement;
    onOpenAssortmentSettings: () => void;
    setScrollToDoorsColumnOnLoad: (newValue: boolean) => void;
    dimensionsPanelApplied: DimensionsPanelReduxState;
    formulaFields: IDisplayFields;
    onUpdateCollectionAttribute: (id: string, prop: string, value: any, reset?: boolean) => void;
    sizingAllocationEnabled: boolean;
    handleSwitchingTileAndGrid?: (switching: boolean) => void;
    metricsEnabled: boolean;
    openDistributionModal: () => void;
    selectedDistribution: Distribution;
    setSelectedDistribution: (value: Distribution) => void;
}

interface IUser {
    identity: string;
    role: string;
}

const ProductCollectionToolbar: React.FunctionComponent<IProps> = ({
    defaultSearchText,
    gridParams,
    hashtags,
    isMobileOrPhablet,
    isMobileOrPhaTablet,
    onClearViewSettings,
    onToggleAddSMUDialog,
    onToggleImageGroups,
    onSearchChange,
    onSwitchView,
    searchText,
    view,
    editable,
    capabilities,
    collectionDriveItem,
    collection,
    onDeleteCollection,
    collectionId,
    gridApi,
    syncingProducts,
    allocatingAssortment,
    findingSizes,
    onSyncProductsStart,
    onSyncProductsStop,
    itemDisplayProperty,
    rowDataSet,
    collectionExport,
    onExport,
    onCreateNordstromPush,
    onClearCollectionExport,
    location,
    brandsDataById,
    onClearViewParams,
    onFiltersChange,
    requiredFieldNames,
    desiredFieldNames,
    getSuggestionData,
    setSuggestionData,
    onRemovePermission,
    showTimeline,
    onToggleTimeline,
    user,
    handleFocusOnCellMap,
    onToggleTotals,
    showTotals,
    onToggleDoors,
    showDoors,
    onChangeDoorGrouping,
    onChangeDoorGroupingLabel,
    onChangePlanMetric,
    doorClassificationSchema,
    doorGrouping,
    doorGroupingLabel,
    dimensionPlanMetrics,
    subscription,
    onSubscribe,
    onUnsubscribe,
    onAllocateAllRows,
    allocationEnabled,
    sizingCurveEnabled,
    sizingRangeEnabled,
    sizePackEnabled,
    onMatchSelectedSizesWithSizeRangesAllRows,
    onToggleManageDoorGrouping,
    onToggleManageAllocationDimension,
    onToggleManagePurchaseOrders,
    onCopy,
    allocationDimensions,
    allocationDimensionGroups,
    accessPlan,
    bulkItems,
    itemId,
    merchantId,
    legacyMerchantId,
    onOpenProductModal,
    showManagePurchaseOrder,
    merchantPurchaseOrderDoorGroups,
    deliveryPurchaseOrders,
    sizeAllocationType,
    onOpenExportToMerchant,
    merchantCurrency,
    tileViewData,
    uniqueBrandEntities,
    listMerchantCollectionVersionStatutes,
    onAddCollectionTag,
    onRemoveCollectionTag,
    poiTags,
    currentPoi,
    genericMerchantAllocationDimensions,
    fetchMerchantPreference,
    fetchMerchantAllocationDimensions,
    requestingMerchantAllocationDimensions,
    defaultDateFormat,
    onConfigureTileView,
    onResetToDefaultTileView,
    selectedTileViewKey,
    sizePacksTolerance,
    updateCollectionSizePacksTolerance,
    onApplyTileViewTemplate,
    isFetchingBrandsData,
    onFetchBrandsData,
    onConfigureTileViewSize,
    tileViewSize,
    merchantFeaturePreference,
    onSyncInventoryUnitsAllRows,
    syncingInventoryUnits,
    isCloseoutAssortmentEnabled,
    userMerchantId,
    isServerRollup,
    onToggleExpandAllGroups,
    expandAllGroups,
    doorTotals,
    doorTotalsFiltered,
    allocationBagRef,
    hideDoorsOptions,
    rootNodeOverride,
    onOpenAssortmentSettings,
    setScrollToDoorsColumnOnLoad,
    dimensionsPanelApplied,
    formulaFields,
    onUpdateCollectionAttribute,
    sizingAllocationEnabled,
    handleSwitchingTileAndGrid,
    metricsEnabled,
    openDistributionModal,
    selectedDistribution,
    setSelectedDistribution,
}) => {
    const flags: FeatureFlags = useFlags();
    const styles = toolbarStyles();
    const { sectionToolbarContentRef, hasDoors, isRollupMode } = React.useContext(ProductCollectionContext);
    const shouldDisplayChip = React.useMemo(() => {
        if (!gridParams) {
            return false;
        }
        const hasFiltersSet = gridParams[GridParamType.Filter] && !isEmpty(gridParams[GridParamType.Filter]);
        const hasSortSet = !!(gridParams[GridParamType.Sort] && gridParams[GridParamType.Sort].length);
        const hasPinnedRowSortSet = !!(
            gridParams[GridParamType.PinnedRowSort] && gridParams[GridParamType.PinnedRowSort].length
        );

        return hasFiltersSet || hasSortSet || hasPinnedRowSortSet;
    }, [gridParams, itemId]); // eslint-disable-line react-hooks/exhaustive-deps
    const [tileViewIcon, setTileViewIcon] = React.useState(TileViewSize.Medium);

    // Remove assortment-manage-distribution flag once deactivated
    const shouldRenderSelectedDistributionChip =
        flags.assortmentManageDistribution &&
        selectedDistribution &&
        selectedDistribution?.value !== DEFAULT_DISTRIBUTION_OPTION.value;

    const handleTotalsToggle = React.useCallback((e) => {
        e.preventDefault();
        onToggleTotals();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleOnToggleDoors = React.useCallback(
        (e) => {
            e.preventDefault();
            onToggleDoors();
            if (!showDoors) {
                setScrollToDoorsColumnOnLoad(true);
            }
        },
        [showDoors] // eslint-disable-line react-hooks/exhaustive-deps
    );

    const handleOnTileView = React.useCallback(
        (e) => {
            if (location.query.cartView === View.Tile) {
                if (tileViewSize === TileViewSize.Small) {
                    onConfigureTileViewSize(TileViewSize.Medium);
                    setTileViewIcon(TileViewSize.Medium);
                } else if (tileViewSize === TileViewSize.Large) {
                    onConfigureTileViewSize(TileViewSize.Small);
                    setTileViewIcon(TileViewSize.Small);
                } else {
                    onConfigureTileViewSize(TileViewSize.Large);
                    setTileViewIcon(TileViewSize.Large);
                }
            }

            e.preventDefault();
            handleSwitchingTileAndGrid(false);
            onSwitchView(View.Tile);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [onConfigureTileViewSize, setTileViewIcon, tileViewSize, location]
    );

    const handleOnGridView = React.useCallback((e) => {
        const view = e.currentTarget.getAttribute("data-view");
        e.preventDefault();
        handleSwitchingTileAndGrid(false);
        onSwitchView(view);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleOnChangeDoorGrouping = (selectedDoorGrouping: string) => (event: React.MouseEvent) => {
        event.preventDefault();
        onChangeDoorGrouping(event, selectedDoorGrouping);
    };

    const handleOnChangeDoorGroupingLabel = (selectedDoorGrouping: string) => (event: React.MouseEvent) => {
        event.preventDefault();
        onChangeDoorGroupingLabel(event, selectedDoorGrouping);
    };

    const handleOnChangePlanMetric = (selectedPlanMetric: string) => (event: React.MouseEvent) => {
        event.stopPropagation();
        onChangePlanMetric(event, selectedPlanMetric);
    };

    const handleIsPlanMetricSelected = (selectedPlanMetric) => {
        return dimensionPlanMetrics.includes(selectedPlanMetric);
    };

    const handleSelectTileViewSize = (tileViewSize: TileViewSize) => () => {
        onConfigureTileViewSize(tileViewSize);
        setTileViewIcon(tileViewSize);
    };

    const handleChangeView = React.useCallback((e) => {
        onSwitchView(e.currentTarget.getAttribute("data-view"));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const dimensionFilters = getDimensionFilters(gridParams);
    const attributeFilters = getAttributeFilters(gridParams);

    const assortmentDimensionMetrics = metricsEnabled;

    const groupSubItems = React.useMemo(() => {
        return [
            ...(!isRollupMode
                ? [
                      ...(!hideDoorsOptions
                          ? [
                                {
                                    name: formatMessage("Assign door groupings"),
                                    onClick: onToggleManageAllocationDimension,
                                    dataTest: DATATEST.ASSORTMENTS.ALLOCATION_DIMENSIONS.MANAGE_DOOR_BTN,
                                },
                            ]
                          : []),
                      showManagePurchaseOrder && {
                          name: formatMessage("Define Purchase Orders"),
                          onClick: onToggleManagePurchaseOrders,
                          dataTest: DATATEST.ASSORTMENTS.DELIVERY_PURCHASE_ORDERS.MANAGE_PO_BTN,
                      },
                      flags.assortmentManageDistribution && {
                          name: formatMessage("Manage Distribution"),
                          onClick: openDistributionModal,
                          dataTest: DATATEST.ASSORTMENTS.MANAGE_DISTRIBUTION_DIALOG_BTN,
                      },
                      ...(!hideDoorsOptions
                          ? [
                                {
                                    name: MenuItemType.Divider,
                                },
                            ]
                          : []),
                  ]
                : []),
            {
                name: !showDoors ? formatMessage("Show doors") : formatMessage("Hide doors"), // flip message based on flag
                onClick: handleOnToggleDoors,
            },
            !isRollupMode && doorClassificationSchema.length > 0 && !hideDoorsOptions
                ? {
                      name: formatMessage("Show doors label"), // todo: add grouping label hide/show logic
                      disabled: !showDoors,
                      dataTest: DATATEST.ASSORTMENTS.SHOW_VIEW_DOOR_LABELS_BTN,
                      nestedItem: doorClassificationSchema.map(
                          (item: any): IViewSubItem => ({
                              name: item.display_name,
                              selected: doorGroupingLabel === item.field_name,
                              onClick: handleOnChangeDoorGroupingLabel(item.field_name),
                              style: menuItemStyles.subMenuItem,
                              rightIcon: doorGroupingLabel === item.field_name && (
                                  <CheckIcon style={menuItemStyles.selectedMenuItem} />
                              ),
                          })
                      ),
                  }
                : null,
            !isRollupMode && doorClassificationSchema.length > 0 && !hideDoorsOptions
                ? {
                      name: formatMessage("Group doors"), // flip message based on flag
                      disabled: !showDoors,
                      dataTest: DATATEST.ASSORTMENTS.GROUP_DOORS_BTN,
                      nestedItem: [
                          ...doorClassificationSchema.map(
                              (item: any): IViewSubItem => ({
                                  name: item.display_name,
                                  selected: doorGrouping === item.field_name,
                                  onClick: handleOnChangeDoorGrouping(item.field_name),
                                  rightIcon: doorGrouping &&
                                      doorGrouping.split(ATTRIBUTE_GROUP_DELIMITER).includes(item.field_name) && (
                                          <CheckIcon style={menuItemStyles.selectedMenuItem} />
                                      ),
                              })
                          ),
                          {
                              name: MenuItemType.Divider,
                          },
                          {
                              name: formatMessage("Manage door grouping"),
                              onClick: onToggleManageDoorGrouping,
                          },
                      ],
                  }
                : null,
            hasDoors && !assortmentDimensionMetrics
                ? {
                      name: showTotals ? formatMessage("Hide door totals") : formatMessage("Show door totals"),
                      onClick: handleTotalsToggle,
                      disabled: accessPlan ? Boolean(dimensionPlanMetrics && dimensionPlanMetrics.length) : accessPlan,
                  }
                : null,
            accessPlan && !isRollupMode && !assortmentDimensionMetrics
                ? {
                      name: formatMessage("Show door plan"),
                      disabled: showTotals,
                      dataTest: DATATEST.ASSORTMENTS.SHOW_DOOR_PLAN_BTN,
                      nestedItem: Object.keys(TotalTypes).map(
                          (type: any): IViewSubItem => ({
                              name: getTotalTypesLabel(TotalTypes[type]),
                              selected: handleIsPlanMetricSelected(TotalTypes[type]),
                              onClick: handleOnChangePlanMetric(TotalTypes[type]),
                              style: menuItemStyles.subMenuItem,
                              rightIcon: handleIsPlanMetricSelected(TotalTypes[type]) && (
                                  <CheckIcon style={menuItemStyles.selectedMenuItem} />
                              ),
                              keepOpenMenuOnSelect: true,
                          })
                      ),
                  }
                : null,
        ].filter((option) => !!option);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        handleOnToggleDoors,
        onToggleManageDoorGrouping,
        doorClassificationSchema,
        showDoors,
        showTotals,
        dimensionPlanMetrics,
        accessPlan,
        doorGroupingLabel,
        doorGrouping,
        showManagePurchaseOrder,
        hideDoorsOptions,
        isRollupMode,
    ]);

    const tileGroupSubItems = React.useMemo(() => {
        const tileViewTemplates = collection.getIn(CollectionKeys.ITEM_DISPLAY_PROPERTY.TILE_VIEW_CONFIGS, List());

        const templateItems = tileViewTemplates.toJS().map((tileViewTemplate, index) => ({
            name: tileViewTemplate.name || `${formatMessage("Preset Uneditable Config")} ${index + 1}`,
            onClick: () =>
                onApplyTileViewTemplate(
                    {
                        firstLine: tileViewTemplate.first_line,
                        secondLine: tileViewTemplate.second_line,
                        thirdLine: tileViewTemplate.third_line,
                        fourthLine: tileViewTemplate.fourth_line,
                        fifthLine: tileViewTemplate.fifth_line,
                        sixthLine: tileViewTemplate.sixth_line,
                        seventhLine: tileViewTemplate.seventh_line,
                        eighthLine: tileViewTemplate.eighth_line,
                        showColorSwatch: tileViewTemplate.show_colorswatch,
                        showUnits: tileViewTemplate.show_units,
                        showDoors: tileViewTemplate.show_doors,
                        showTotalCost: tileViewTemplate.show_total_cost,
                        showTotalRetail: tileViewTemplate.show_total_retail,
                        showEachesOnHover: tileViewTemplate.show_eaches_on_hover,
                    },
                    index
                ),
            dataTest: `${DATATEST.ASSORTMENTS.TILE.TEMPLATE_TILE_VIEW_BTN}-${index + 1}`,
            rightIcon: selectedTileViewKey === index ? <CheckIcon style={menuItemStyles.selectedMenuItem} /> : null,
        }));

        return [
            {
                name: formatMessage("Default Configuration"),
                onClick: onResetToDefaultTileView,
                dataTest: DATATEST.ASSORTMENTS.TILE.DEFAULT_TILE_VIEW_BTN,
                rightIcon:
                    selectedTileViewKey === DEFAULT_VIEW_SETTINGS ? (
                        <CheckIcon style={menuItemStyles.selectedMenuItem} />
                    ) : null,
            },
            ...templateItems,
            {
                name: MenuItemType.Divider,
            },
            {
                name: formatMessage("Image Size"),
                nestedItem: [
                    {
                        name: formatMessage("Small"),
                        onClick: handleSelectTileViewSize(TileViewSize.Small),
                        leftIcon: <TileSmall />,
                        rightIcon:
                            tileViewSize === TileViewSize.Small ? (
                                <CheckIcon style={menuItemStyles.selectedMenuItem} />
                            ) : null,
                    },
                    {
                        name: formatMessage("Medium"),
                        onClick: handleSelectTileViewSize(TileViewSize.Medium),
                        leftIcon: <TileMedium />,
                        rightIcon:
                            tileViewSize === TileViewSize.Medium ? (
                                <CheckIcon style={menuItemStyles.selectedMenuItem} />
                            ) : null,
                    },
                    {
                        name: formatMessage("Large"),
                        onClick: handleSelectTileViewSize(TileViewSize.Large),
                        leftIcon: <TileLarge />,
                        rightIcon:
                            tileViewSize === TileViewSize.Large ? (
                                <CheckIcon style={menuItemStyles.selectedMenuItem} />
                            ) : null,
                    },
                ],
            },
            {
                name: formatMessage("Configure Tile View"),
                onClick: onConfigureTileView,
                dataTest: DATATEST.ASSORTMENTS.TILE.CONFIGURE_TILE_VIEW_BTN,
                rightIcon:
                    selectedTileViewKey === CUSTOM_VIEW_SETTINGS ? (
                        <CheckIcon style={menuItemStyles.selectedMenuItem} />
                    ) : null,
            },
            {
                name: formatMessage("Expand All Groups"),
                onClick: onToggleExpandAllGroups,
                dataTest: DATATEST.ASSORTMENTS.TILE.EXPAND_TILE_VIEW_BTN,
                rightIcon: expandAllGroups ? <CheckIcon style={menuItemStyles.selectedMenuItem} /> : null,
            },
        ];
    }, [tileViewSize, selectedTileViewKey, collection, expandAllGroups]); // eslint-disable-line react-hooks/exhaustive-deps

    const StoreIconComponent = React.useMemo(() => <StoreIcon color="inherit" />, []);

    const tileIcon = React.useMemo(() => {
        return tileViewIcon === TileViewSize.Small ? (
            <TileSmall />
        ) : tileViewIcon === TileViewSize.Large ? (
            <TileLarge />
        ) : (
            <Tile />
        );
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const tableIcon = React.useMemo(() => <TableIcon />, []);

    if ((!sectionToolbarContentRef || !sectionToolbarContentRef.current) && !rootNodeOverride) {
        return null;
    }

    let selectedCollectionId;
    const viewIdQuery = location.query?.viewId;
    if (isServerRollup && viewIdQuery) {
        const [_, collectionId] = viewIdQuery.split(CollectionSavedViewRollupSeparator);
        selectedCollectionId = collectionId;
    }

    return ReactDOM.createPortal(
        <div className="assortmentToolbar" {...styles}>
            <SearchAssortments
                isServerRollup={isServerRollup}
                defaultSearchText={defaultSearchText}
                hashtags={hashtags}
                onSearchChange={onSearchChange}
                view={view}
                searchText={searchText}
                merchantId={merchantId}
                collectionId={collectionId}
            />
            {hasDoors && (
                <ProductCollectionToolbarFilters
                    allocationDimensions={allocationDimensions}
                    onFiltersChange={onFiltersChange}
                    appliedFilters={{
                        dimensionFilters,
                        attributeFilters,
                    }}
                    isServerRollup={isServerRollup}
                    collectionId={selectedCollectionId}
                />
            )}
            <div
                className={`actions ${
                    location.query.cartView === View.History || location.query.cartView === View.Dataloss
                        ? "inHistory"
                        : ""
                }`}
            >
                {shouldRenderSelectedDistributionChip && (
                    <CustomChip.Root
                        tooltip={selectedDistribution.label}
                        onClick={() => setSelectedDistribution(DEFAULT_DISTRIBUTION_OPTION)}
                    >
                        <DistributionIcon />
                        <CustomChip.Text>{selectedDistribution.label}</CustomChip.Text>
                    </CustomChip.Root>
                )}
                <CurrentSavedViewChip
                    className="savedView"
                    collectionId={collectionId}
                    onClearViewParams={onClearViewParams}
                    isRollupMode={isRollupMode}
                />

                {shouldDisplayChip && !isMobileOrPhaTablet && (
                    <Chip
                        className="resetView"
                        classes={{
                            label: "chipLabel",
                        }}
                        label={formatMessage("Reset Filters & Sort")}
                        icon={<FilterListIcon />}
                        onDelete={onClearViewSettings}
                        data-test={DATATEST.ASSORTMENTS.RESET_FILTER_SORT_VIEW}
                    />
                )}

                {shouldDisplayChip && <div className="spacer" />}

                {!isRollupMode && siteConfig.ASSMT_FEED === "true" && !isMobileOrPhaTablet && (
                    <Button
                        dataTest={DATATEST.ASSORTMENTS.UPDATES_BTN}
                        active={showTimeline}
                        key={View.Timeline}
                        onClick={onToggleTimeline}
                        label={formatMessage("Updates")}
                        icon={<Timeline />}
                    />
                )}

                {allocationDimensions.length > 0 && allocationEnabled && (
                    <NestedViewButton
                        key={View.Door}
                        view={View.Door}
                        dataTestMoreButton={DATATEST.ASSORTMENTS.DOOR_MENU_BTN}
                        // Only enable when there are doors and grid is not grouped by any allocation dimension
                        buttonActive={showDoors && allocationDimensionGroups.length === 0}
                        dropdownActive={allocationDimensionGroups.length === 0}
                        onClick={handleOnToggleDoors}
                        name={formatMessage("Doors")}
                        icon={StoreIconComponent}
                        dataTest={DATATEST.ASSORTMENTS.DOORS_BTN}
                        subItems={groupSubItems}
                        style={nestedViewButtonStyle}
                    />
                )}

                {!isMobileOrPhablet && editable && <div className="spacer" />}
                {!isMobileOrPhablet && location.query.cartView !== View.History && (
                    <NestedViewButton
                        key={View.Tile}
                        view={View.Tile}
                        dataTestMoreButton={DATATEST.ASSORTMENTS.TILE_MENU_BTN}
                        buttonActive={view === View.Tile}
                        dropdownActive={view === View.Tile}
                        onClick={handleOnTileView}
                        name={formatMessage("Tile")}
                        icon={tileIcon}
                        dataTest={DATATEST.ASSORTMENTS.TILE_VIEW_BTN}
                        subItems={tileGroupSubItems}
                        style={nestedViewButtonStyle}
                    />
                )}
                {!isMobileOrPhablet && location.query.cartView !== View.History && (
                    <NestedViewButton
                        key={View.Grid}
                        view={View.Grid}
                        buttonActive={view === View.Grid}
                        dropdownActive={view === View.Tile}
                        onClick={handleOnGridView}
                        name={formatMessage("Grid")}
                        icon={tableIcon}
                        dataTest={DATATEST.ASSORTMENTS.GRID_VIEW_BTN}
                        subItems={[]}
                        style={nestedViewButtonStyle}
                    />
                )}
                <div className="spacer" />
                {isServerRollup ? (
                    <ProductRollupActionsView
                        collectionExport={collectionExport}
                        onClearCollectionExport={onClearCollectionExport}
                        onExport={onExport}
                        allocationDimensions={allocationDimensions}
                        gridApi={gridApi}
                        doorTotals={doorTotals}
                        doorTotalsFiltered={doorTotalsFiltered}
                        collectionDriveItem={collectionDriveItem}
                        onUpdateCollectionAttribute={onUpdateCollectionAttribute}
                        verticalAssortmentsEnabled={flags.verticalAssortmentsEnabled}
                    />
                ) : location.query.cartView === View.History ? (
                    " "
                ) : (
                    <ProductCollectionActions
                        brandsDataById={brandsDataById}
                        collection={collection}
                        collectionName={nameExtRemover(collectionDriveItem?.name, ItemKind.CollectionDocument)}
                        collectionBrandId={collection.getIn([
                            "brand_collection_properties",
                            "struct_value",
                            "brand_id",
                        ])}
                        merchantName={collection.getIn(CollectionKeys.ITEM_DISPLAY_PROPERTY.MERCHANT_NAME)}
                        collectionExport={collectionExport}
                        collectionId={collectionId}
                        editable={editable}
                        gridApi={gridApi}
                        isMobileOrPhablet={isMobileOrPhablet}
                        isMobileOrPhaTablet={isMobileOrPhaTablet}
                        capabilities={capabilities}
                        collectionDriveItem={collectionDriveItem}
                        itemDisplayProperty={itemDisplayProperty}
                        bulkItems={bulkItems}
                        location={location}
                        onClearCollectionExport={onClearCollectionExport}
                        onExport={onExport}
                        onCreateNordstromPush={onCreateNordstromPush}
                        onDeleteCollection={onDeleteCollection}
                        onSwitchView={onSwitchView}
                        onSyncProductsStart={onSyncProductsStart}
                        onSyncProductsStop={onSyncProductsStop}
                        onCopy={onCopy}
                        rowDataSet={rowDataSet}
                        syncingProducts={syncingProducts}
                        allocatingAssortment={allocatingAssortment}
                        findingSizes={findingSizes}
                        onToggleImageGroups={onToggleImageGroups}
                        onToggleAddSMUDialog={onToggleAddSMUDialog}
                        requiredFieldNames={requiredFieldNames}
                        desiredFieldNames={desiredFieldNames}
                        getSuggestionData={getSuggestionData}
                        setSuggestionData={setSuggestionData}
                        onRemovePermission={onRemovePermission}
                        handleFocusOnCellMap={handleFocusOnCellMap}
                        user={user}
                        subscription={subscription}
                        onUnsubscribe={onUnsubscribe}
                        onSubscribe={onSubscribe}
                        onAllocateAllRows={onAllocateAllRows}
                        allocationEnabled={allocationEnabled}
                        sizingCurveEnabled={sizingCurveEnabled}
                        sizingRangeEnabled={sizingRangeEnabled}
                        sizePackEnabled={sizePackEnabled}
                        onMatchSelectedSizesWithSizeRangesAllRows={onMatchSelectedSizesWithSizeRangesAllRows}
                        allocationDimensions={allocationDimensions}
                        handleChangeView={handleChangeView}
                        view={view}
                        views={views}
                        showTimeline={showTimeline}
                        onToggleTimeline={onToggleTimeline}
                        itemId={itemId}
                        merchantId={merchantId}
                        legacyMerchantId={legacyMerchantId}
                        onOpenProductModal={onOpenProductModal}
                        merchantPurchaseOrderDoorGroups={merchantPurchaseOrderDoorGroups}
                        deliveryPurchaseOrders={deliveryPurchaseOrders}
                        sizeAllocationType={sizeAllocationType}
                        onOpenExportToMerchant={onOpenExportToMerchant}
                        merchantCurrency={merchantCurrency}
                        tileViewData={tileViewData}
                        doorTotals={doorTotalsFiltered}
                        versionStatuses={listMerchantCollectionVersionStatutes}
                        uniqueBrandEntities={uniqueBrandEntities}
                        onAddCollectionTag={onAddCollectionTag}
                        onRemoveCollectionTag={onRemoveCollectionTag}
                        poiTags={poiTags}
                        currentPoi={currentPoi}
                        genericMerchantAllocationDimensions={genericMerchantAllocationDimensions}
                        fetchMerchantPreference={fetchMerchantPreference}
                        fetchMerchantAllocationDimensions={fetchMerchantAllocationDimensions}
                        requestingMerchantAllocationDimensions={requestingMerchantAllocationDimensions}
                        defaultDateFormat={defaultDateFormat}
                        sizePacksTolerance={sizePacksTolerance}
                        updateCollectionSizePacksTolerance={updateCollectionSizePacksTolerance}
                        isFetchingBrandsData={isFetchingBrandsData}
                        onFetchBrandsData={onFetchBrandsData}
                        merchantFeaturePreference={merchantFeaturePreference}
                        onSyncInventoryUnitsAllRows={onSyncInventoryUnitsAllRows}
                        syncingInventoryUnits={syncingInventoryUnits}
                        isCloseoutAssortmentEnabled={isCloseoutAssortmentEnabled}
                        userMerchantId={userMerchantId}
                        allocationBagRef={allocationBagRef}
                        onOpenAssortmentSettings={onOpenAssortmentSettings}
                        flags={flags}
                        dimensionsPanelApplied={dimensionsPanelApplied}
                        formulaFields={formulaFields}
                        sizingAllocationEnabled={sizingAllocationEnabled}
                    />
                )}
            </div>
        </div>,
        rootNodeOverride ? rootNodeOverride : sectionToolbarContentRef.current
    );
};

// separate export statement so function name shows up in React DevTools
export { ProductCollectionToolbar };
